var $505ae4d15a8bf0f5$exports = {};
$505ae4d15a8bf0f5$exports = {
    "more": `Mais itens`
};


export {$505ae4d15a8bf0f5$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
